module.exports = __webpack_public_path__ + "static/img/1048.1f160ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/1048.png
// module id = hxFk
// module chunks = 0